import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  getCurrentUserApiV1UsersMeGet,
  getGetCurrentUserApiV1UsersMeGetQueryKey,
  recordTermsDecisionApiV1UsersMeTermsDecisionPost,
} from '@/services/api/user/user';
import { TermsDecisionType } from '@/shared/types/api/termsDecisionType';
import { useUserStore } from '@/store/userStore';
import { userRequiresTermsAcceptance } from '../utils/termsAcceptance';

export function useTermsAndConditions() {
  const queryClient = useQueryClient();
  const user = useUserStore((state) => state.user);
  const isUserLoading = useUserStore((state) => state.isLoading);
  const setUser = useUserStore((state) => state.setUser);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isWaitingForUser = isUserLoading || !user;
  const isBlocking = !!user && userRequiresTermsAcceptance(user);

  const acceptTerms = useCallback(async () => {
    setIsSubmitting(true);

    try {
      await recordTermsDecisionApiV1UsersMeTermsDecisionPost({
        decision: TermsDecisionType.accept,
      });

      const updatedUser = await getCurrentUserApiV1UsersMeGet();
      setUser(updatedUser);
      queryClient.setQueryData(getGetCurrentUserApiV1UsersMeGetQueryKey(), updatedUser);
    } finally {
      setIsSubmitting(false);
    }
  }, [queryClient, setUser]);

  return {
    isBlocking,
    isLoading: isWaitingForUser,
    isSubmitting,
    acceptTerms,
  };
}
